var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === 'loading')?_c('v-layout',{style:(("height: " + _vm.height + "px;")),attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }